// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"187":"9d0e3e08e1acb601ef99","245":"540b53c643b0764a307d","428":"1e9c87e1f8637ba22848","975":"d94e43f8eb409441d35c"}[chunkId] + ".min.js";
};